function AppShell({
  children,
  maxWidth = "1200px",
  padded = true,
  background = "radial-gradient(circle at top, #101010 0%, #000 55%)",
}) {
  return (
    <div
      className="app-shell"
      style={{
        minHeight: "100vh",
        background,
        color: "#fff",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        className={
          padded ? "app-shell__content app-shell__content--padded" : "app-shell__content"
        }
        style={{
          maxWidth,
          margin: "0 auto",
          padding: padded ? "24px 20px 100px" : "0",
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default AppShell;
